export default [
  {
    path: "portfolio",
    name: "Histórico Portfolio",
    component: () =>
      import("@/app/modules/portfolio/pages/portfolio.historic.component.vue"),
  },
];
